import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import COInlineMessage from '@components/ringil3/COInlineMessage/COInlineMessage';
import RingilButton from '@components/ringil3/Buttons/RingilButton';
import RingilDialog from '@components/RingilComponents/RingilDialog.tsx';
import { isNotNullOrUndefined } from '@utils/utils';

interface ComponentProps {
  onDelete: (objToDelete: any) => void;
  dataTestId?: string;
}

export const useCreateDeleteDialog = () => {
  const [objToDelete, setObjToDelete] = useState(undefined);

  const DeleteDialog: React.FC<ComponentProps> = ({ onDelete, dataTestId }) => {
    const { tr } = useTranslationLgs();
    return (
      <RingilDialog
        visible={isNotNullOrUndefined(objToDelete)}
        heading={tr(`DeleteDialog.realyDelete`, `Realy delete`)}
        onHide={() => setObjToDelete(undefined)}
        dataTestId={dataTestId}
        footer={
          <>
            <RingilButton
              label={tr(`RingilSidebar.yesDelete`, `Yes, delete`)}
              onClick={() => {
                onDelete(objToDelete);
                setObjToDelete(undefined);
              }}
              mode={'filled-rectangle'}
              size={'big'}
              iconPath={'/images/icons/ringil3/buttons/deleteWhite.svg'}
              dataTestId={`${dataTestId}-delete`}
            />
            <RingilButton label={tr(`RingilSidebar.back`, `Back`)} onClick={() => setObjToDelete(undefined)} mode={'link'} size={'big'} dataTestId={`${dataTestId}-back`} />
          </>
        }
      >
        <COInlineMessage variant={'warning'} buttons={null}>
          {tr(`DeleteDialog.deleteWarning`, `Be careful, deletion cannot be undone`)}
        </COInlineMessage>
      </RingilDialog>
    );
  };

  return { DeleteDialog, setObjToDelete };
};
